import ReactDOM from 'react-dom';
import Router from './router';

localStorage.clear();
ReactDOM.render(Router, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js